import React from 'react';
import AddBudgetReappropriate from '../../components/BudgetReappropriate/AddBudgetReappropriate';


export default function AddBudgetReappropriatePage() {
    return (
        <div>
          <AddBudgetReappropriate />
        </div>
      )
}